import { createSlice } from '@reduxjs/toolkit';
import { getCardiologists } from '../../../rtk-apis/users/getCardiologists';

type Cardiologist = {
  _id: string;
  name?: string;
  email?: string;
  role?: string;
  hospitalId?: string;
  clinicName?: string;
};

const initialState = {
  status: '',
  data: [] as Cardiologist[],
  msg: '',
  loading: false,
};

const getCardiologistsSlice = createSlice({
  name: 'getCardiologistsSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCardiologists.pending, state => {
        state.loading = true;
      })
      .addCase(getCardiologists.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || [];
        state.msg = action?.payload?.msg;
      })
      .addCase(getCardiologists.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = [];
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getCardiologistsSlice.actions;
export default getCardiologistsSlice.reducer;
